import { Guid } from '@project/types';
import { networkService } from '@project/services';

import { AxiosResponse } from 'axios';

import statementUrl from './statement.url';

const createStatementPaymentLink = (id: Guid, source: number) => {
  const url = statementUrl.getStatementPaymentLinkUrl(id);
  return networkService
    .post(url, { source }, { timeout: 0 })
    .then((apiResponse: AxiosResponse<string>) => apiResponse.data);
};

export default {
  createStatementPaymentLink,
};
